/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/global/disqus.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'shared/global/disqus', exports: {} };
const exports = module.exports;



import { Fandango as Fandango_context } from '@take-2/fd-modules/splits/require-core';

const { context: { config, movieDetails } } = Fandango_context;


import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { fd_url_manager as links } from '@take-2/fd-modules/splits/require-core';



import { Fandango_xhr as xhr } from '@take-2/fd-modules/splits/require-core';

function onFail(err) {
    return debugLog.error(module.name, 'API failure', err);
}
function onDone() {
    if (!window.DISQUS) {
        return;
    }
    window.DISQUS.reset({
        reload: true,
        config() {
            let topicId = config.discus.identifier || 'default'; // possible values: blog_id, video_id, photo_id
            if (movieDetails && movieDetails.id) {
                topicId = 'mid' + movieDetails.id;
            }
            this.page.identifier = topicId;
            this.page.shortname = config.discus.shortname;
            this.page.url = window.location.href.replace(/\?.+$/, '');
            this.page.title = document.title;
        }
    });
}
function init() {
    if (!config.discus) {
        return;
    }
    xhr.ajax({
        url: links.disqus({ shortname: config.discus.shortname }),
        dataType: 'script',
        method: 'GET',
    })
        .done(onDone)
        .fail(onFail);
}
export default {
    init,
};
